module.exports = __webpack_public_path__ + "e61eb26aa4279bd0ca611d1e3c62f814.svg";